import PracticeAreaTemplate from '../../components/PracticeAreaTemplate';
import { usePracticeArea } from '../../hooks/usePracticeArea';

export default function CorporatePage() {
  const pa = usePracticeArea('corporate');
  return <PracticeAreaTemplate pa={pa} />;
}
